<template lang="pug">
  .d-flex.flex-column.align-items-center.justify-content-center.text-center
    Avatar.mb-3(:platform="conversation.platform", :src="userData.profile_pic") {{ conversation }}
    h5.mb-2 {{ userName.trim() || 'Usuario' }}
    b-badge.mb-4(:variant="botEnabled ? 'soft-success' : 'soft-danger'") {{ botEnabled ? 'Bot activo' : 'Bot desactivado' }}
    b-tabs.text-left.w-100
      b-tab(title="Información")
        b-card
          p.mb-0 Estatus del bot
          b-form-checkbox.text-secondary(switch, v-model="botEnabled", @change="changed") {{ botEnabled ? 'Bot activo' : 'Bot desactivado' }}
          hr
          p.mb-0 Suscrito a campañas
          b-form-checkbox.text-secondary(switch, v-model="isSubscribed", @change="updateIsSubscribedInUser") {{ isSubscribed ? 'Suscrito' : 'No suscrito' }}
          hr
          p.mb-0 Usuario bloqueado
          b-form-checkbox.text-secondary(switch, v-model="isBanned", @change="updateBannedInUser") {{ isBanned ? 'Sí' : 'No' }}
          hr
          p.mb-0 Plataforma
          p.text-secondary.mb-0 {{ userPlatform.title }}
          hr
          p.mb-0 Primer interacción
          p.text-secondary.mb-0 {{ $moment(userData.createdAt).format('DD/MM/YYYY, HH:mmA') }}
          hr
          p.mb-0 Última interacción
          p.text-secondary.mb-0 {{ $moment(userData.last_interaction_time).format('DD/MM/YYYY, HH:mmA') }}
          hr
          b-row.align-items-center.justify-content-between.mb-3
            b-col(cols="6")
              p.mb-0 ID externo
              p.text-secondary.mb-0#external-id {{ userData.external_id }}
            b-col(cols="auto")
              copy-icon.icon-md.pointer.hover-primary#copy-external-id-icon(@click="copy")
              b-tooltip(target="copy-external-id-icon", triggers="focus click blur", ref="copy-tooltip") Copiado
      b-tab(title="Historial de casos", v-if="casesHistory")
        div.max-h-100
          b-card(id="caseCard", v-for="(oneCase, index) in casesHistory.slice((currentPage - 1) * perPage, (currentPage - 1) * perPage + perPage)", :key="index")
            b-row
              b-col
                p.mt-0 ID del caso:
              b-col
                p.text-secondary.mb-0 {{ oneCase.case_id }}
            b-row
              b-col
                p.mt-0 Fecha de creación:
              b-col
                p.text-secondary.mb-0 {{ new Date(oneCase.createdAt).toLocaleDateString('Mx', { year:"numeric", month:"short", day:"numeric" }) }}
            b-row
              b-col
                p.mt-0 Estatus:
              b-col
                p.text-secondary.mb-0 {{ oneCase.status }}
            b-row
              b-col
                p.mt-0 Etiquetas:
                p.text-help(v-if="!oneCase.Tags.length") Sin etiquetas
                b-badge.mr-1.mb-1.opacity-50(v-for="(tag, indexTag) in oneCase.Tags", :key="indexTag", :style="{'background-color': tag.color, color: BWTextColor(tag.color)}") {{ tag.name }}
            hr
          b-pagination.d-flex.justify-content-center(aria-controls="caseCard", v-model="currentPage", :per-page="perPage", :total-rows="casesHistory.length")
    b-container.d-flex.justify-content-center.align-items-baseline.mb-4
      b-button.mr-2(:variant="downloadConversationStatus?'secondary':'primary'" @click="downloadConversation" :disabled="downloadConversationStatus" size="sm" ) {{downloadConversationStatus?'Descargando...':'Descargar conversación'}}
      b-button(v-if="contact", variant="primary", @click="side_modal = true" size="sm") Información de contacto
      b-button(v-else, variant="primary", @click="contacts_modal = true" size="sm") Asociar contacto
    b-card.w-100
      UserProperties(v-if="userId", :user-id="userId")
      user-variables(:platform="userPlatform.name", @update:values="getUserAttributesValues")
    SideModal(v-model="side_modal", size="lg", @input="side_modal = false")
      template(v-if="side_modal && contact")
        Contact(:contact_id="contact._id")
    // ASIGN CONTACT MODAL
    b-modal(v-model="contacts_modal", size="lg", title="Asociar contacto a la conversación", cancel-title="Cancelar", ok-title="Asociar", ok-variant="primary", @ok="assignContact", :ok-disabled="!contact_selected", scrollable)
      b-input-group.mb-3
        b-form-input(placeholder="Buscar contacto...", v-model="search_contact", type="search")
        b-input-group-append
          b-input-group-text
            search-icon.text-secondary.icon-sm
      b-table.table-nowrap.mb-0.scrollable-area.mt-2(:items="contacts", :fields="contacts_fields", responsive, :filter="search_contact", selectable, select-mode="single", @row-selected="selectContact", selectedVariant="secondary", ref="contacts_table")
        template(v-slot:empty)
          p.text-help.mb-0.text-center.my-4 {{search_contact ? 'No hay coincidencias' : 'No hay contactos creados'}}
        template(v-slot:cell(name)="{ item }") {{ item.first_name }} {{ item.last_name }}
        template(v-slot:table-busy)
          .text-center
            b-spinner(variant="primary")
</template>

<script>

import Avatar from './Avatar.vue'
import boxes from '../data/boxes'
import { BWTextColor } from '../helpers/contrast-color-generator'
import ContactData from './ContactData'
import Contact from './Contact.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import debounce from 'lodash.debounce'
import Download from 'downloadjs'
import { EventBus } from '../helpers/eventBus'
import { sendNotification } from '../helpers/notification'
import UserVariables from './UserVariablesList'
import UserProperties from './UserProperties'

const contactController = createNamespacedHelpers('contact')
const platformController = createNamespacedHelpers('platform')

export default {
  data() {
    return {
      perPage: 1,
      currentPage: 1,
      casesHistory: [],
      userId: null,
      downloadConversationStatus: false,
      filters_open: false,
      side_modal: false,
      contacts_modal: false,
      boxes: boxes,
      conversation_admins: [],
      updateTimeout: null,
      botEnabled: true,
      isSubscribed: true,
      isBanned: false,
      conversation: {},
      contact: null,
      contact_selected: null,
      search_contact: '',
      contacts_fields: [
        { key: 'full_name', label: 'Contacto' },
        { key: 'phone', label: 'Teléfono' },
        { key: 'email', label: 'Correo' }
      ]
    }
  },
  inject: {
    caseSocket: { default: Object }
  },
  computed: {
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    ...contactController.mapState({
      contacts: state => state.contacts
    }),
    userData() {
      return (this.conversation && this.conversation.user) ? this.conversation.user : {}
    },
    userName() {
      return Object.keys(this.userData).length ? `${this.userData.first_name || ''} ${this.userData.last_name || ''}` : ''
    },
    userPlatform() {
      const userPlatform = this.userData.platform
      const found = this.platforms.find(platform => platform.name == userPlatform)

      return found ? found : 'Desconocida'
    }
  },
  watch: {
    conversation(newConversation) {
      if (newConversation && newConversation.user) {
        this.getContact(newConversation.user.user_id)
      }
    }
  },
  methods: {
    ...mapActions([
      'contact/all',
      'conversation/get',
      'conversation/update',
      'user/updateBotStatus',
      'user/update',
      'user/cases',
      'account/userAttributesValues',
      'user/contact',
      'contact/asociate'
    ]),
    async createCaseHistory() {
      this['user/cases']({
        user_id: this.userId,
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          this.casesHistory = res.resource
        }
      })
    },
    downloadConversation() {
      const { conversation_id: conversationId } = this.$route.params
      const { external_id: externalId } = this.userData
      const username = this.userName.trim() || externalId

      this.caseSocket.emit('downloadConversation', { conversationId })

      this.downloadConversationStatus = true

      this.caseSocket.once('downloadConversation', (data) => {
        sendNotification(
          `Reporte del chat con ${username} terminado`,
          'Tu conversación ha sido descargada'
        )
        this.downloadConversationFile(data)

        this.downloadConversationStatus = false
      })
    },
    downloadConversationFile({ buffer }) {
      const timestamp = new Date().getTime()
      const { external_id: externalId } = this.userData
      const username = this.userName.trim() || externalId
      const conversation = `${username}_conversation_${timestamp}.csv`

      Download(buffer, conversation, 'text/csv;charset=utf-8')
    },
    getConversation() {
      this['conversation/get']({
        conversation_id: this.$route.params.conversation_id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)

          this.conversation = res.resource
          this.botEnabled = res.resource.bot_enabled
          this.isSubscribed = res.resource.user ? res.resource.user.is_subscribed : true
          this.userId = res.resource.user_id
          this.isBanned = res.resource.user ? res.resource.user.banned : false

          this.getUserAttributesValues()
        }
      })
    },
    getUserAttributesValues() {
      const self = this

      this['account/userAttributesValues']({
        account_id: self.$route.params.account_id,
        user_id: self.userData.user_id,
        params: { platform: self.conversation.platform },
        callback: res => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    async getContact(userId) {
      this.userId = userId
      this.loading = true
      const self = this

      this['user/contact']({
        user_id: userId,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          self.contact = res.resource

          this.createCaseHistory()
        }
      })
    },
    updateBotStatus: debounce(function () {
      this['user/updateBotStatus']({
        platform: this.conversation.platform,
        bot_enabled: this.botEnabled,
        user_id: this.userData.user_id,
        callback: res => {
          this.hideLoadingScreen()

          if (res.error) return this.$message.error(res.error)

          EventBus.$emit(
            'conversationId',
            {
              _id: this.conversation._id,
              bot_enabled: this.botEnabled
            }
          )

          this.$message.success(`Bot ${this.botEnabled ? 'activado' : 'desactivado'}`)
        }
      })
    }, 300),
    changed() {
      this.$nextTick(() => {
        this.updateBotStatus()
      })
    },
    copy() {
      const self = this
      const dummy = document.createElement('textarea')

      document.body.appendChild(dummy)
      dummy.value = this.userData.external_id
      dummy.select()

      document.execCommand('copy')
      document.body.removeChild(dummy)

      setTimeout(function () {
        self.$refs['copy-tooltip'].$emit('close')
      }, 1000)
    },
    getContacts () {
      this.loading = true
      const self = this

      if (this.contacts.length) return

      this['contact/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)
        }
      })
    },
    selectContact (items) {
      this.contact_selected = items[0]
    },
    assignContact () {
      this.loading = true
      let self = this

      this['contact/asociate']({
        contact_id: this.contact_selected._id,
        ...self.conversation,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Contacto asociado')
            self.contact = res.resource
          }
        }
      })
    },
    updateIsSubscribedInUser(value) {
      const self = this
      this.loading = true

      this['user/update']({
        user_id: self.userData.user_id,
        is_subscribed: value,
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Usuario actualizado')
        }
      })
    },
    updateBannedInUser(value) {
      const self = this
      this.loading = true

      this['user/update']({
        user_id: self.userData.user_id,
        banned: value,
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)

          self.$message.success('Usuario actualizado')
        }
      })
    },
    BWTextColor: BWTextColor,
  },
  mounted() {
    this.getContacts()
    this.$nextTick(() => { this.getConversation() })
  },
  components: { Avatar, UserVariables, ContactData, Contact, UserProperties }
}
</script>

<style lang="scss" scoped>
.scrollable-container-sm {
  max-height: 200px;
  overflow: hidden;
  overflow-y: auto;
  word-break: break-all;
}

.collapse-icon {
  transition: 0.3s;
}

.upsidedown {
  transform: rotate(-180deg);
}
</style>
